<template>
    <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
      <a-form-model-item label="标题" prop="subject" >
        <a-input v-model="form.subject" placeholder="请输入邮件标题" />
      </a-form-model-item>
      <a-form-model-item label="邮箱列表" prop="emails" >
        <a-input v-model="form.emails" placeholder="请输入邮箱列表  多个邮箱使用,隔开" />
      </a-form-model-item>
      <a-form-model ref="form" :model="form" :rules="rules">
          <a-form-model-item label="内容" prop="content">
          <a-textarea
          v-model="form.content"
          :rows="10"
          :auto-size="{ minRows: 10, maxRows: 20 }" 
          style="font-family: monospace; white-space: pre;"
          />
      </a-form-model-item>
      <a-form-model-item label="图片" prop="coverUrl" >
        <a-upload
          listType="picture-card"
          class="avatar-uploader"
          v-model="form.coverUrl"
          :showUploadList="false"
          action="https://web.frameflash.com/admin-api/common/local/file/uploadCos"
          :beforeUpload="beforeUpload"
          :customRequest="handleChange"
        >
          <plus-outlined />
          <img v-if="form.coverUrl" :src="form.coverUrl" alt="logo" style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="图片地址" prop="imgUrl" >
        <a-input v-model="form.imgUrl" placeholder="邮件正文中需要图片,请将此URL放入正文" />
      </a-form-model-item>
      <a-form-model-item label="时间类型" prop="pushType" >
        <a-select v-model="form.pushType" prop="pushType">
          <a-select-option :value="0">立即发送</a-select-option>
          <!-- <a-select-option :value="1">指定时间</a-select-option> -->
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="发送时间" prop="sendTime" v-if="form.pushType == 1" >
        <a-date-picker
          style="width: 100%"
          v-model="form.sendTime"
          format="YYYY-MM-DD HH:mm"
          allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="请输入备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入备注" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getPush, addPush, updatePush } from '@/api/video/emailPush'
import Editor from '@/components/Editor'
import UploadFileToVOD from "@/api/vod.js"
import { uploadCos } from '@/api/common/index'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        subject: null,

        emails: null,

        content: `<!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <style>
                        /* 默认邮件样式 */
                        .email-container { max-width: 600px; margin: 0 auto; }
                    </style>
                </head>
                <body>
                    <div class="email-container">
                        <!-- 用户内容区 -->
                        <img src="">
                    </div>
                </body>
                </html>`,
        pushType: null,

        sendTime: null,

        remark: null,

        coverUrl: null,

        imgUrl: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        subject: [
          { required: true, message: '标题不能为空'}
        ],
        content: [
          { required: true, message: '内容不能为空'}
        ],
        pushType: [
            { required: true, message: '类型 0-立即推送  1-定时推送', trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    queryVideoList() {
      const param = {}
      listVideo(param).then(response => {
        this.videoList = response.data
      })
    },
    handleChange(info) {

        let that = this
        new UploadFileToVOD([info.file], {
        success: function (fileName) {
            that.form.imgUrl = fileName[0];//文件名
            that.form.coverUrl = fileName[0];//文件名
            that.uploadLoading = false;
        },

        });
        that.uploadLoading = false;

    },
    beforeUpload: function (file) {
        var fileType = file.type;
        if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        this.uploadLoading=false
        return false;
        }
        this.form.coverUrl=""
        //TODO 驗證文件大小
    },
    handleUpload(info) { //上传主图(一张图)
        console.log(info)
        let that = this;
        this.form.coverUrl = "";
        this.uploadLoading = true;
        uploadCos(info.file)
        //  , function (fileName) {
        //   console.log('--------------------------------')
        //   console.log(fileName)
        //   console.log('--------------------------------')
        //   that.uploadLoading = false;
        //   that.form.coverUrl = fileName;
        // }
        },
    onClose () {
      this.reset()
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,

        subject: null,

        content: null,

        emails: null,

        pushType: null,

        sendTime: null,

        imgUrl: null,

        coverUrl: null,

        remark: null,
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getPush({ 'id': id }).then(response => {
        this.form = response.data
        debugger
        console.log(this.form)
        this.open = true
        this.formTitle = '修改'
      })
    },
    formatDateTime(dateTimeStr) {
      // 假设dateTimeStr是形如"YYYY-MM-DD HH:mm:ss"的字符串
      debugger
      if (!dateTimeStr) {
        dateTimeStr = new Date()
      }
      const dateTime = new Date(dateTimeStr)

      // 检查日期是否有效
      if (isNaN(dateTime.getTime())) {
        throw new Error('Invalid date time string')
      }

      // 获取并格式化日期和时间的各个部分
      const year = dateTime.getFullYear()
      const month = String(dateTime.getMonth() + 1).padStart(2, '0') // 月份从0开始，所以需要+1
      const day = String(dateTime.getDate()).padStart(2, '0')
      const hours = String(dateTime.getHours()).padStart(2, '0')
      const minutes = String(dateTime.getMinutes()).padStart(2, '0')
      const seconds = String(dateTime.getSeconds()).padStart(2, '0')

      // 使用模板字符串进行格式化
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          this.form.sendTime = this.formatDateTime(this.form.sendTime)
          this.form.isDeleted = null;
          if (this.form.id !== undefined && this.form.id !== null) {
            console.log('表单内容：', this.form)
            updatePush(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addPush(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
